module.exports = __webpack_public_path__ + "img/footer-purple.e9e0234b.png";